import { DOCUMENT, inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class StyleLoaderService {
    private readonly _document = inject(DOCUMENT);
    private readonly _isBrowser = isPlatformBrowser(inject(PLATFORM_ID));
    private readonly _cache = new Map<string, Promise<void>>();

    load(url: string): Promise<void> {
        if (!this._isBrowser) {
            return Promise.resolve();
        }

        const cached = this._cache.get(url);
        if (cached) {
            return cached;
        }

        const promise = new Promise<void>((resolve, reject) => {
            const link = this._document.createElement('link');
            link.rel = 'stylesheet';
            link.href = url;
            link.addEventListener('load', () => resolve());
            link.addEventListener('error', () => reject(new Error(`Failed to load stylesheet: ${url}`)));
            this._document.head.appendChild(link);
        });

        this._cache.set(url, promise);
        return promise;
    }
}
